<template>
  <ValidationProvider :name="name" :vid="vid" rules="required" v-slot="{ errors }" mode="passive" tag="div">
    <div class="row mx-n2" :class="{ oneColumn: oneColumn }">
      <div class="col-sm-6 px-2 radio-btn" v-for="(option, index) in options" :key="`${name}-${index}`">
        <input
          :id="`${name}-${option.value}`.replace(/\s+/g, '_').toLowerCase()"
          type="radio"
          v-model="innerValue"
          :name="name"
          :value="option.value"
          autocomplete="off"
        />
        <label :for="`${name}-${option.value}`.replace(/\s+/g, '_').toLowerCase()">
          <div class="icon primary-fill-svg">
            <inline-svg :src="require('@/assets/fa/test-drive-' + option.value + '.svg')" alt="" />
          </div>
          <span class="h5">{{ option.label }}</span>
          <span class="p d-block">{{ option.description }}</span>
          <span class="float-right svgIcon primary-fill-svg">
            <slot name="icon">
              <!--Add the svgIcon to the slot if you are using your own-->
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
                <path
                  fill="#007bc7"
                  fill-rule="evenodd"
                  d="M18 10a8 8 0 1 1-16 0 8 8 0 0 1 16 0zm-8.925 4.236L15.01 8.3a.516.516 0 0 0 0-.73l-.73-.73a.516.516 0 0 0-.73 0l-4.84 4.841-2.26-2.26a.516.516 0 0 0-.73 0l-.73.73a.516.516 0 0 0 0 .73l3.355 3.355a.516.516 0 0 0 .73 0z"
                ></path>
              </svg>
            </slot>
          </span>
        </label>
      </div>
    </div>
  </ValidationProvider>
</template>
<script>
import { ValidationProvider } from 'vee-validate';

export default {
  name: 'RouteRadio',
  components: {
    ValidationProvider,
  },
  props: {
    options: {
      type: Array,
      required: true,
    },
    vid: {
      type: Number,
    },
    value: {
      type: null,
    },
    name: {
      // name can be anything, It just has to be unqiue from another instance of this component in the same form.
      type: String,
      required: true,
    },
    oneColumn: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      innerValue: '',
    };
  },
  watch: {
    // Handles internal model changes.
    innerValue(newVal) {
      this.$emit('input', newVal);
    },
    // Handles external model changes.
    value(newVal) {
      this.innerValue = newVal;
    },
  },
  created() {
    if (this.value) {
      this.innerValue = this.value;
    }
  },
};
</script>
<style scoped lang="scss">
@import 'src/assets/scss/variables';
.radio-btn {
  margin-bottom: 8px;
  position: relative;
  label {
    background: #ffffff;
    position: relative;
    width: 100%;
    height: 100%;
    min-height: 100px;
    margin: 0;
    border-radius: 6px;
    padding: 16px 30px 18px 80px;
    cursor: pointer;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.06);
    border: 1px solid #dae2ea;
    .p {
      color: #19222b;
      margin-top: 0;
      font-size: 14px;
      line-height: 21px;
      max-width: 250px;
    }
    .svgIcon {
      position: absolute;
      right: 10px;
      top: 10px;
      display: none;
    }
  }

  .icon {
    position: absolute;
    left: 0;
    top: 0;
    width: 80px;
    height: 100px;
    text-align: center;
    svg {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      margin: auto;
    }
  }

  input[type='radio'] {
    opacity: 0;
    position: absolute;
  }

  input[type='radio']:checked + label {
    background: $primary-light-background;
    border: 1px solid $primary;

    .svgIcon {
      display: block;
    }
  }
}

@media (min-width: 575px) {
  .radio-btn {
    break-inside: avoid;
    margin-bottom: 16px;
  }
  .oneColumn {
    .radio-btn {
      margin-right: 50%;
    }
  }
}
</style>
